import { JSDOM } from 'jsdom';
import '@formatjs/intl-enumerator/polyfill';
import '@formatjs/intl-datetimeformat/polyfill';
const dompurify = require('dompurify');

const createDOMPurify = dompurify.default;

const jsdomWindow = new JSDOM('').window;
global.DOMPurify = createDOMPurify(jsdomWindow);
globalThis.DOMPurify = global.DOMPurify;
